export default __webpack_public_path__ + "static/studio-slider-5-471337081c50a141929a28ea7317660e.png";